import api from "@/services/api";

export default {
  state: {
    oas: [],
    limit: 4,
    offset: 0,
    total: 0,
    search: "",
    location: null,
    temporality: null,
  },
  getters: {
    getOas(state: { oas: [] }) {
      return state.oas;
    },
  },
  mutations: {
    setOas(state: { oas: []; total: number }, oas: []) {
      state.oas = oas;
    },
    setTotal(state: { total: number }, total: number) {
      state.total = total;
    },
    setOffset(state: { offset: number }, page: number) {
      state.offset = page;
    },
    setLimit(state: { limit: number }, limitN: number) {
      state.limit = limitN;
    },
    setSearch(state: { search: string }, searchQ: string) {
      state.search = searchQ;
    },
    setLocation(state: { location: number }, locationL: number) {
      state.location = locationL;
    },
    setTemporality(state: { temporality: number }, temporalityT: number) {
      state.temporality = temporalityT;
    },
  },
  actions: {
    async AgetOas({ commit, state }: any): Promise<void> {
      try {
        let url = `lobjects/?limit=${state.limit}&offset=${state.offset}`;
        if (state.search && state.search.length > 0) {
          url += `&search=${state.search}`;
        }
        if (state.location != null) {
          url += `&loc=${state.location}`;
        }
        if (state.temporality != null) {
          url += `&temp=${state.temporality}`;
        }
        const resp = await api.get(url);
        commit("setOas", resp.data);
        commit("setTotal", resp.data.length);
      } catch (error) {
        console.error(error);
      }
    },
    async updateOffset({ commit, dispatch }: any, page: number): Promise<void> {
      commit("setOffset", page);
      await dispatch("AgetOas");
    },
  },
};
